import { render, staticRenderFns } from "./SampleCharacterization.vue?vue&type=template&id=b26c8536&scoped=true"
import script from "./SampleCharacterization.vue?vue&type=script&lang=js"
export * from "./SampleCharacterization.vue?vue&type=script&lang=js"
import style0 from "./SampleCharacterization.vue?vue&type=style&index=0&id=b26c8536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b26c8536",
  null
  
)

export default component.exports